module.exports = __webpack_public_path__ + "VIPV28.png?6b367eb29a15c20f8753ca09eb0ccd55";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV28.png
// module id = 123
// module chunks = 0